import styled, { StyledComponentProps } from 'styled-components'
import { NoSelectStyles } from '../shared/styled/NoSelectStyles.styled'

interface IProps {
    size?: string
    active?: boolean
}

export const StyledSearchIcon = (props: IProps & StyledComponentProps<'svg', any, {}, never>) => {
    return (
        <StyledSvg viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path d="M21.6331 21.4753L26.0313 26.5625M24.4375 15.4063C24.4375 19.8073 20.8698 23.375 16.4688 23.375C12.0677 23.375 8.5 19.8073 8.5 15.4063C8.5 11.0052 12.0677 7.4375 16.4688 7.4375C20.8698 7.4375 24.4375 11.0052 24.4375 15.4063Z" strokeWidth="1.34211" strokeLinecap="round" />
        </StyledSvg>
    )
}

const StyledSvg = styled.svg<IProps>`
    ${NoSelectStyles}

    width: ${p => p.size || '30px'};
    height: ${p => p.size || '30px'};
    stroke: ${p => (p.active ? p.theme.playColor : p.theme.textColor)};
`
